export default __webpack_public_path__ + "static/media/home.b912a0f4.svg";